import * as React from 'react';
import * as PropTypes from 'prop-types';
import ReactTableComponent from 'components/ReactTableComponent';
import DateFormats from 'constants/DateFormats';
import moment from 'moment';

class BankAccountTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };

    this.columns = [
      {
        Header: 'Наименование банка',
        accessor: 'bankName',
        sortable: true,
        width: 260,
      },
      {
        Header: 'Номер счета',
        accessor: 'accountNumber',
        sortable: true,
        width: 220,
      },
      {
        Header: () => (
          <>
            Дата <br /> открытия
          </>
        ),
        accessor: 'startDate',
        sortable: true,
        Cell: DateCell,
        width: 120,
      },
      {
        Header: () => (
          <>
            Дата <br /> закрытия
          </>
        ),
        accessor: 'endDate',
        sortable: true,
        Cell: DateCell,
        width: 120,
      },
      {
        Header: 'Вид счета',
        accessor: 'type',
        sortable: true,
      },
      {
        Header: 'Состояние счета',
        accessor: 'status',
        Cell: ({ value }) => {
          if (value === 'Y') {
            return 'Открыт';
          } else if (value === 'N') {
            return 'Закрыт';
          } else {
            return 'В ликвидированном банке';
          }
        },
        sortable: true,
        width: 200,
      },
    ];
  }

  render() {
    const {
      data,
      paginationOptions,
      isLoading,
      fetchNextPage,
      onSortedChange,
      defaultSorted,
    } = this.props;
    return (
      <ReactTableComponent
        columns={this.columns}
        manual={true}
        tableData={data || []}
        paginationOptions={paginationOptions}
        fetchNextPage={fetchNextPage}
        isLoading={isLoading}
        onSortedChange={onSortedChange}
        theme={'blue'}
        defaultSorted={defaultSorted}
      />
    );
  }
}

BankAccountTable.propTypes = {
  data: PropTypes.array,
  defaultSorted: PropTypes.array,
  paginationOptions: PropTypes.object,
  isLoading: PropTypes.bool,
  fetchNextPage: PropTypes.func,
  onSortedChange: PropTypes.func,
};
export default BankAccountTable;

function DateCell(property) {
  let dateString = property.value && moment(property.value).format(DateFormats.long);
  return <div>{dateString}</div>;
}
